module.exports = __webpack_public_path__ + "assets/img/X2.483cafef.png";